import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import { SET_DEFINITION, SET_DEFINITIONS } from "./actions";
import SelectionState from "state/selections/SelectionState";
import produce from "immer";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      state.definitions[SelectionState.UNCOMMITTED][0] = action.definition;
      if (action.commit) {
        state.definitions[SelectionState.COMMITTED] =
          state.definitions[SelectionState.UNCOMMITTED];
      }
      break;
    }

    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }

    case COMMIT_SELECTIONS:
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;

    default:
      return state;
  }
});

export default reducer;
